import { routing } from "../../routing.js";
export function createClient(api) {
  async function signup(payload) {
    const url = `${routing.billing}/signup`;
    return api.post(url, {
      payload
    });
  }
  async function getPlan() {
    const {
      plan
    } = await api.get(`${routing.billing}/plan`);
    return plan;
  }
  return {
    signup,
    getPlan
  };
}